<template></template>

<script>
import config from '@/config/'
export default {
  props: {
    merchantId: {
      //这个就是父组件中子标签自定义名字
      type: Number,
      default: 0
    },
    signReq:{
      type: String,
      default: '',
    }
  },
  data() {
    return {
      retryTime: 3000,
      clientId: 's_mch_',
      timer: '',
      retryMaxCount: 10
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.retryDestroy();
  },
  methods: {
    init() {
      // this.$store.dispatch('resetCounter');
      this.clientId = this.clientId + this.merchantId;
      this.initSocket();
    },
    initSocket() {
      if(this.clientId==0){
        return
      }
      this.retryDestroy();
      this.$WebSocket.WebSocketFn(this.clientId,this.signReq, res => {
        if (!res) {
          console.log('this.$store.state--->',this.$store.state)
          this.$store.dispatch('reConnectCounter');
          this.$message.error(`与服务端通信失败，正在尝试第${this.$store.state.Counter.main}次连接！`);
          console.log(`与服务端通信失败，正在尝试第${this.$store.state.Counter.main}次连接！`);
          if (this.$store.state.Counter.main > this.retryMaxCount) {
            var msg = `与服务端通信失败，已超过最大重试次数，请联系管理员！`;
            console.log(msg);
            this.$message.error(msg);
            return;
          }
          this.timer = setInterval(this.initSocket, this.retryTime + this.$store.state.Counter.main * 1000);
          return;
        }
        this.retundata();
        this.onclose();
      });
    },
    retryDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
    retundata() {
      // 监听接受到websocket的信息
      this.$WebSocket.onmessage(res => {
        console.log('接收来自其他客户端的消息---->', res);
        this.$store.dispatch('addSocketMsg', res);
      });
    },
    onclose() {
      // 监听长连接的一个断开
      this.$WebSocket.ws.onclose = e => {
        console.log('与服务端通信已断开,原因：', e);
        if (e.code !== 1000) {
          console.log('this.$store.state-->',this.$store.state)
          // 非正常关闭
          let info = this.$store.state.Counter.main;
          if (info < this.retryMaxCount) {
            this.initSocket();
          } else {
            console.log('断开连接2');
            this.$WebSocket.websocketclose();
            this.$message.error('与服务重新连接重试已超过最大次数，请联系管理员');
            ipcRenderer.sendSync('setSalver-window', {
              text: '网络错误，请重启应用',
              index: 1
            });
          }
        } else {
          this.$WebSocket.websocketclose();
          this.$message.warning('与服务通信连接已断开');
        }
      };
    }
  }
};
</script>

<style></style>
